<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Sales iCal for {{huis.huis_code }} </p>
    <v-form ref="showICal">
     
     <span class="mx-2"> <a :href=huis.huis_ical_url>{{huis.huis_ical_url}}</a> </span>
     
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huis_encrid: null,
      huis: {}
    }
  },
  methods: {
    open(huis_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huis_encrid = huis_encrid;
      this.$axios
        .post("ares/json/ares/huis/getHuisToShowICal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToShowICal"
          },
          getHuisToShowICal: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToShowICal;
            deze.huis_encrid = huis_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

